import React, { useState } from 'react';
import './BarChart.css';

function BarChart({ data, metric, height = 250 }) {
  const [hoveredBar, setHoveredBar] = useState(null);
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  
  if (!data || data.length < 2) {
    return (
      <div className="chart-placeholder" style={{ height: `${height}px` }}>
        <div className="no-data">Need at least 2 data points</div>
      </div>
    );
  }
  
  // Sort data by date (newest first, then reverse for chart)
  const sortedData = [...data].sort((a, b) => 
    new Date(b.snapshot_date) - new Date(a.snapshot_date)
  ).reverse();
  
  // Extract monthly values
  const values = sortedData.map(item => item.monthly_total);
  const maxValue = Math.max(...values) || 1;
  
  // Calculate label display interval based on data count
  const dataCount = values.length;
  let labelInterval = 1;
  if (dataCount > 10) labelInterval = 2;
  if (dataCount > 20) labelInterval = 3;
  if (dataCount > 40) labelInterval = 5;
  
  // Format metric labels
  const formatValue = (value) => {
    if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
    if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
    return value.toString();
  };
  
  // Format full value for tooltip
  const formatFullValue = (value) => {
    return value.toLocaleString();
  };
  
  // Format dates
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };
  
  return (
    <div className="inventory-bar-chart-wrapper" style={{ height: `${height}px` }}>
      {/* Grid background */}
      <div className="inventory-bar-grid"></div>
      
      {/* Y-axis labels */}
      <div className="inventory-bar-y-axis">
        {[1, 0.75, 0.5, 0.25, 0].map((ratio, idx) => (
          <div key={idx} className="inventory-bar-y-label">
            {formatValue(maxValue * ratio)}
          </div>
        ))}
      </div>
      
      {/* Bars container with flexbox */}
      <div className="inventory-bar-container">
        {values.map((value, index) => {
          const heightPercent = (value / maxValue) * 100;
          
          return (
            <div key={index} className="inventory-bar-wrapper">
              <div 
                className="inventory-bar"
                style={{ height: `${heightPercent}%` }}
                onMouseEnter={(e) => {
                  setHoveredBar({ value, date: sortedData[index].snapshot_date });
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                }}
                onMouseMove={(e) => setTooltipPos({ x: e.clientX, y: e.clientY })}
                onMouseLeave={() => setHoveredBar(null)}
              />
              {index % labelInterval === 0 && (
                <div className="inventory-bar-x-label">
                  {formatDate(sortedData[index].snapshot_date)}
                </div>
              )}
            </div>
          );
        })}
      </div>
      
      {/* Hover Tooltip */}
      {hoveredBar && (
        <div 
          className="inventory-bar-tooltip"
          style={{
            left: tooltipPos.x,
            top: tooltipPos.y
          }}
        >
          {formatDate(hoveredBar.date)}: {formatFullValue(hoveredBar.value)}
        </div>
      )}
    </div>
  );
}

export default BarChart;
